const state = {
  site: {}
}
export default state
